import auth, { ISignIn, resendVerificationCode, signInV2 } from '../services/auth';
import { RECAPTCHA_STORAGE_KEY } from '../constants/storage';
import { getRecaptcha } from '../services/recaptcha';
import resolveChallenge from './resolveChallenge';
import storage from '../services/storage';
import routing from '../services/routing';
import routes from '../constants/routes';
import { EMAIL_VERIFICATION_REQUIRED, EMAIL_VERIFICATION_V3_REQUIRED } from '../constants/errorCodes';
import { LOGIN_V2 } from '../constants/auth';

export default async (form: ISignIn) => {
    const includeRecaptcha = storage.loadState(RECAPTCHA_STORAGE_KEY);
    const { username, password } = form;
    let res;
    try {
        if (includeRecaptcha) {
            const token = await getRecaptcha().execute();
            res = LOGIN_V2
                ? await signInV2(form)
                : await auth.signIn({
                      password,
                      recaptcha: true,
                      token,
                      username,
                  });
            // on succesful login remove recaptcha
            getRecaptcha().unmount();
            storage.saveState(RECAPTCHA_STORAGE_KEY, false);
        } else {
            try {
                res = LOGIN_V2 ? await signInV2(form) : await auth.signIn(form);
            } catch (error) {
                await getRecaptcha().render();
                throw error;
            }
        }

        resolveChallenge({
            ...res.data,
            username,
        });
    } catch (error) {
        if (
            error instanceof Error &&
            [EMAIL_VERIFICATION_V3_REQUIRED, EMAIL_VERIFICATION_REQUIRED].includes(error.message)
        ) {
            const version = error.message === EMAIL_VERIFICATION_V3_REQUIRED ? '3' : '2';
            routing.push(routes.SIGN_UP_COMPLETE_EMAIL.replace(':version', version), {
                username: encodeURIComponent(form.username),
            });
            resendVerificationCode({ username }, version);
        } else {
            throw error;
        }
    }
};
